import { SmallBusinessSentAppsRepository } from '@/application/smallBusiness/domain/SmallBusinessSentAppsRepository';
import { UseCase } from '@/shared/application/UseCase';
import { UUID } from '@hfc/common';
import { SfApiResponse } from '@hfc/ui-core';

export class SetApplicationSentUuidUseCase implements UseCase<UUID, SfApiResponse> {

  private repository: SmallBusinessSentAppsRepository;

  public constructor (repository: SmallBusinessSentAppsRepository) {
    this.repository = repository;
  }

  public async run (uuid: UUID): Promise<SfApiResponse> {
    return await this.repository.setSentApplicationUuid(uuid);
  }

}
